export default __webpack_public_path__ + "locales/pt-BR/OAuth.json?hash=fd099d20c24e18b5a27e446959bdf2b1";